<template>
  <div class="search">
    <div class="filters">
      <recipe-order />
    </div>
    <results-bar
      :total="filteredRecipes.length"
      :label="resultsLabel"
      icon="search"
      tile-selector=".search-card"
    />
    <div class="content container">
      <recipe-tile
        class="search-card"
        v-for="recipe in filteredRecipes.slice(0, this.nrOfRecipesToShow)"
        :recipe="recipe"
        :key="recipe.id"
      />
    </div>
    <load-more />
  </div>
</template>

<script>
import RecipeTile from "./recipe/RecipeTile";
import RecipeOrder from "./recipe/RecipeOrder";
import LoadMore from "@/components/common/LoadMore";
import ResultsBar from "@/components/common/ResultsBar";

export default {
  created() {
    this.$store.commit('setTitle', 'Søk')
    if(this.$store.getters.currentCategory.Name != 'Søk')
      this.$store.dispatch("setCurrentCategory", "Søk");
  },
  computed: {
    filteredRecipes() {
      return this.$store.getters.filteredRecipes;
    },
    nrOfRecipesToShow() {
      return this.$store.getters.nrOfRecipesToShow;
    },
    isSearching() {
      const q = this.$store.getters.searchString || '';
      return q.trim().length > 0;
    },
    resultsLabel() {
      const n = this.filteredRecipes.length;
      if (this.isSearching) return n === 1 ? 'søgeresultat' : 'søgeresultater';
      return n === 1 ? 'opskrift' : 'opskrifter';
    }
  },
  components: {
    "recipe-tile": RecipeTile,
    "recipe-order": RecipeOrder,
    "load-more": LoadMore,
    "results-bar": ResultsBar
  }
};
</script>

<style lang="scss">
</style>